import { lazy, type ReactNode } from "react";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const CustomerGroups = lazy(() => import("./CustomerGroups"));
const CustomerGroupEdit = lazy(() => import("./CustomerGroupEdit"));
const CustomerGroupView = lazy(() => import("./ViewPages/CustomerGroupView"));

export default function CustomerGroupIndex(): Array<ReactNode> {
    return [
        <PermissionRoute
            permissions={[ "see_customer_groups" ]}
            title="Customer Groups | Shopfront"
            path="/customer-groups"
            key="customer-groups"
            element={<CustomerGroups />}
        />,
        <PermissionRoute
            permissions={[ "edit_customer_groups", "adjust_customer_group" ]}
            title="Edit Customer Group | Shopfront"
            path="/customer-group/:id/edit"
            key="customer-group-edit"
            element={<CustomerGroupEdit />}
        />,
        <PermissionRoute
            permissions={[ "see_customer_groups" ]}
            title="View Customer Group | Shopfront"
            path="/customer-group/:id"
            key="customer-group-view"
            element={<CustomerGroupView />}
        />,
    ];
}
